export const supportedLanguages = ['en', 'zh-CN'];
export const languageOptions = [
  { key: 'en', text: 'English' },
  { key: 'zh-CN', text: '简体中文' },
];

const languageKey = 'change-language';
const languagePreferenceVersionKey = 'change-language-version';
const languagePreferenceVersion = 'english-chinese-v1';

export function normalizeLanguage(value) {
  const normalized = String(value || '').trim().toLowerCase().replace('_', '-');
  if (normalized === 'zh' || normalized === 'zh-cn' || normalized.startsWith('zh-hans')) {
    return 'zh-CN';
  }
  return normalized === 'en' || normalized.startsWith('en-') ? 'en' : '';
}

export function getStoredLanguage() {
  const candidates = [
    localStorage.getItem(languageKey),
    localStorage.getItem('lang'),
    localStorage.getItem('language'),
    sessionStorage.getItem(languageKey),
  ];
  return candidates.map(normalizeLanguage).find(Boolean) || 'en';
}

export function persistLanguage(language = getStoredLanguage()) {
  const value = normalizeLanguage(language) || 'en';

  localStorage.setItem(languageKey, value);
  localStorage.setItem('lang', value);
  localStorage.setItem('language', value);
  localStorage.setItem(languagePreferenceVersionKey, languagePreferenceVersion);
  sessionStorage.setItem(languageKey, value);
  document.cookie = `${languageKey}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
  document.documentElement.setAttribute('lang', value);

  return value;
}

export function getRequestFallbacks() {
  return getStoredLanguage() === 'zh-CN'
    ? {
        success: '操作成功',
        requestFailed: '请求失败，请稍后重试。',
        timeout: '服务器响应超时，请稍后重试。',
        networkFailed: '网络请求失败',
      }
    : {
        success: 'Success',
        requestFailed: 'Request failed. Please try again.',
        timeout: 'The server took too long to respond. Please try again.',
        networkFailed: 'Network request failed',
      };
}
